<template>
  <div>
    <el-dialog
      :title="'用户[' + userNickName + ']视频考试列表'"
      :visible.sync="videoIsShow"
      width="735px"
      append-to-body
    >
      <el-table
        :data="videoList"
        v-loading="listLoading"
        stripe
        :header-cell-style="{ background: '#F5F7FA' }"
      >
        <el-table-column
          property="ExamNum"
          label="考试序号"
          width="80"
        ></el-table-column>
        <el-table-column property="QuestionsTitle" label="考试题目" width="260">
          <template slot-scope="scope">
            <span>{{ scope.row.QuestionsTitle || "--" }}</span>
          </template>
        </el-table-column>
        <!-- <el-table-column
        property="CreateTime"
        label="操作时间"
        width="150"
      ></el-table-column> -->
        <el-table-column property="Reason" label="用户作答视频地址" width="200">
          <template slot-scope="scope">
            <span>{{ scope.row.EngineerAnswer || "--" }}</span>
          </template>
        </el-table-column>

        <el-table-column label="操作" fixed="right" width="120">
          <template slot-scope="scope">
            <el-button size="mini" @click="videoPlay(scope.row)"
              >查看视频</el-button
            >
          </template>
        </el-table-column>
      </el-table>

      <div class="form-div">
        <el-form ref="form" label-width="100px" :inline="true">
          <el-form-item label="打分分数：">
            <el-input
              v-model.number="userScore"
              style="width: 150px"
            ></el-input>
          </el-form-item>
          <el-form-item>
            <el-button type="primary" @click="onSubmit">提交</el-button>
          </el-form-item>
        </el-form>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import {
  getActVideoExamResoultList, // 获取视频考试列表
  setVideoScore,
} from "@/service/run";
export default {
  // props: {
  //   userName: {
  //     type: String,
  //   },
  // },
  data() {
    return {
      videoIsShow: false,
      listLoading: false,
      videoList: [],

      wxUnionId: "",
      userNickName: "",
      userScore: "",
      lastResoultId: 0,
    };
  },
  methods: {
    openDia(row) {
      this.videoIsShow = true;
      console.log(row);
      this.userScore = "";
      this.lastResoultId = 0;
      if (row) {
        this.wxUnionId = row.UnionId;
        this.userNickName = row.NickName;
        this.lastResoultId = row.SecondExamResoultId;
        if (row.SecondScore <= 0) {
          this.userScore = "";
        } else {
          this.userScore = row.SecondScore;
        }
      }
    },
    async loadList() {
      this.listLoading = true;
      var data = {
        UnionId: this.wxUnionId,
      };
      console.log(data);

      let res = await getActVideoExamResoultList(data);
      this.listLoading = false;
      if (res.Result != 1) {
        return this.$message.error("获取失败请联系开发人员");
      }

      // console.log(res);
      if (res.Result != 1) {
        return this.$message.error(res.Message);
      }
      //   this.$message({ message: res.Message, type: "success" });

      this.$nextTick(() => {
        this.videoList = res.Data;
        console.log("videoList:" + this.videoList);
      });
    },

    videoPlay(row) {
      console.log("用户答题-videoPlay");
      this.$emit("videoPlay", row);
    },
    onSubmit() {
      //打分提交
      if (this.lastResoultId <= 0) {
        return this.$message.error("获取考试信息失败，请关闭弹窗重试");
      }
      if (this.userScore == "" || this.userScore <= 0) {
        return this.$message.error("请输入打分分数");
      }
      if (isNaN(this.userScore)) {
        return this.$message.warning("打分分数请输入数字");
      }

      var data = {
        ExamResoultId: this.lastResoultId,
        Score: this.userScore,
      };

      setVideoScore(data).then((res) => {
        if (res.Result != 1) {
          return this.$message.error(res.Message);
        }
        this.$message({ message: res.Message, type: "success" });
        this.videoIsShow = false;
        this.$emit("reloadList");
      });
    } 
  },
};
</script>

<style scoped>
.el-dialog__body {
  padding: 10px;
}
.form-div {
  padding-top: 30px;
  /* border: 1px solid red; */
}
</style>